<div class="container-fluid clearfix">
  <div class="d-flex flex-wrap">
    <div>
      <h2 mat-dialog-title>What would you like to download ?</h2>

      <mat-dialog-content>
        File Type
        <mat-radio-group aria-label="Select an option" class="radio-group-line" [(ngModel)]="formatOption">
          <mat-radio-button class="radio-button" *ngFor="let option of formatOptions" [value]="option">
            {{ option.name }}
          </mat-radio-button>
        </mat-radio-group>
        Delivery Method
        <mat-radio-group aria-label="Select an option" class="radio-group-line" [(ngModel)]="methodOption"
          (click)="deliveryMethodClick()">
          <mat-radio-button class="radio-button" *ngFor="let option of methodOptions" [value]="option">
            {{ option.name }}
          </mat-radio-button>
        </mat-radio-group>

        <mat-form-field *ngIf="isEmail()" style="width: 315px">
          <input data-testid="email-field" required #emailBox matInput placeholder="Email Address" aria-label="Email"
            [formControl]="emailCtrl" />
          <mat-hint align="end">Not more then 60 characters long.</mat-hint>
          <mat-error *ngIf="emailCtrl.hasError('email') && !emailCtrl.hasError('required')" data-testid="email-field">
            Please enter a valid email address
          </mat-error>
          <mat-error *ngIf="emailCtrl.hasError('required')">
            Email is <strong>required</strong>
          </mat-error>
          <mat-error *ngIf="emailCtrl.hasError('maxlength')">You have more than 60 characters.
          </mat-error>
        </mat-form-field>
      </mat-dialog-content>

      <mat-dialog-actions>
        <div align="end">
          <button mat-flat-button (click)="dialogRef.close(false)">Cancel</button>
          <button [class.primary-button-disabled]="disableSubmitButton" [class.primary-button]="!disableSubmitButton"
            [disabled]="disableSubmitButton" mat-raised-button color="primary" (click)="submit()">
            Submit
          </button>
        </div>
      </mat-dialog-actions>

    </div>

    <div *ngIf="dataSource.data.length > 0" class="table-download">
      <h2 mat-dialog-title>Available Downloads</h2>
      <table *ngIf="dataSource.data.length > 0" mat-table [dataSource]="dataSource" class="mat-elevation-z8"
        data-testid="table" class="table-container">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Format</th>
          <td mat-cell *matCellDef="let element">{{element.view}}</td>
        </ng-container>

        <!-- Download Column -->
        <ng-container matColumnDef="download">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let download">
            <button mat-stroked-button *ngIf="!download.isLoading; else withoutLink" (click)="callDownload(download)">
              {{'Download'}}
            </button>
          </td>
          <ng-template #withoutLink>
            Processing...
            <mat-progress-bar data-testid="processing" mode="indeterminate"></mat-progress-bar>
          </ng-template>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

    </div>
  </div>
</div>